import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '@/layouts/DashboardLayout';

// Public & auth pages
import Home from '@/app/page';
import Login from '@/app/login/page';
import Signup from '@/app/signup/page';
import SignupSuccess from '@/app/signup/success/page';
import ForgotPassword from '@/app/forgot-password/page';
import Join from '@/app/join/page';
import Privacy from '@/app/privacy/page';
import Support from '@/app/support/page';
import DataDeletion from '@/app/data-deletion/page';
import Register from '@/app/(public)/register/page';

// Dashboard pages
import Dashboard from '@/app/(dashboard)/dashboard/page';
import Users from '@/app/(dashboard)/users/page';
import UserDetail from '@/app/(dashboard)/users/detail/page';
import UserDiet from '@/app/(dashboard)/users/diet/page';
import Gyms from '@/app/(dashboard)/gyms/page';
import Staff from '@/app/(dashboard)/staff/page';
import Trainers from '@/app/(dashboard)/trainers/page';
import Classes from '@/app/(dashboard)/classes/page';
import Plans from '@/app/(dashboard)/plans/page';
import Payments from '@/app/(dashboard)/payments/page';
import Billing from '@/app/(dashboard)/billing/page';
import Subscriptions from '@/app/(dashboard)/subscriptions/page';
import DietPlansV2 from '@/app/(dashboard)/diet-plans-v2/page';
import DietCalendar from '@/app/(dashboard)/diet-calendar/page';
import FoodLibrary from '@/app/(dashboard)/food-library/page';
import ExercisePlans from '@/app/(dashboard)/exercise-plans/page';
import Reviews from '@/app/(dashboard)/reviews/page';
import Promotions from '@/app/(dashboard)/promotions/page';
import Store from '@/app/(dashboard)/store/page';
import Chat from '@/app/(dashboard)/chat/page';
import CheckIn from '@/app/(dashboard)/check-in/page';
import Appointments from '@/app/(dashboard)/appointments/page';
import FinancialReports from '@/app/(dashboard)/financial-reports/page';
import Profile from '@/app/(dashboard)/profile/page';
import GymSettings from '@/app/(dashboard)/gym-settings/page';
import ClassBookings from '@/app/(dashboard)/class-bookings/page';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signup/success" element={<SignupSuccess />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/join" element={<Join />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/register" element={<Register />} />

      {/* Dashboard layout: pathless parent so child paths are /dashboard, /users, etc. */}
      <Route element={<DashboardLayout />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users/detail" element={<UserDetail />} />
        <Route path="users/diet" element={<UserDiet />} />
        <Route path="gyms" element={<Gyms />} />
        <Route path="staff" element={<Staff />} />
        <Route path="trainers" element={<Trainers />} />
        <Route path="classes" element={<Classes />} />
        <Route path="plans" element={<Plans />} />
        <Route path="payments" element={<Payments />} />
        <Route path="billing" element={<Billing />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="diet-plans" element={<Navigate to="/diet-plans-v2" replace />} />
        <Route path="diet-plans-v2" element={<DietPlansV2 />} />
        <Route path="diet-calendar" element={<DietCalendar />} />
        <Route path="food-library" element={<FoodLibrary />} />
        <Route path="exercise-plans" element={<ExercisePlans />} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="store" element={<Store />} />
        <Route path="chat" element={<Chat />} />
        <Route path="check-in" element={<CheckIn />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="financial-reports" element={<FinancialReports />} />
        <Route path="profile" element={<Profile />} />
        <Route path="gym-settings" element={<GymSettings />} />
        <Route path="class-bookings" element={<ClassBookings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
